import * as ACTION_TYPES from "./actionTypes";

const { UPDATE_GENERAL_PROPS, DELETE_GENERAL_PROPS, MERGE_GENERAL_PROPS } = ACTION_TYPES;
export const updateGeneralProp = (prop, value) => {
  return { type: UPDATE_GENERAL_PROPS, payload: [{ prop, value }] };
};
export const updateGeneralProps = payload => {
  return { type: UPDATE_GENERAL_PROPS, payload: payload };
};
export const mergeGeneralProps = payload => {
  return { type: MERGE_GENERAL_PROPS, payload: payload };
};
export const deleteGeneralProp = prop => {
  return { type: DELETE_GENERAL_PROPS, payload: [{ prop }] };
};
export const deleteGeneralProps = payload => {
  return { type: DELETE_GENERAL_PROPS, payload };
};
